import { useState } from 'react'
import { router } from '@inertiajs/react'
import { Plus, Trash2, Users } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { AddContactSheet } from './AddContactSheet'

interface OpportunityContact {
  id: number
  contact_id: number
  contact_name: string
  contact_email?: string
  role_key: string
  role: { value: number; label: string }
}

interface OpportunityContactsProps {
  opportunityId: number
  contacts: OpportunityContact[]
  isTerminal: boolean
}

export function OpportunityContacts({
  opportunityId,
  contacts,
  isTerminal,
}: OpportunityContactsProps) {
  const [addOpen, setAddOpen] = useState(false)

  function handleRemove(contactAssocId: number) {
    router.delete(`/fundraising/opportunities/${opportunityId}/opportunity_contacts/${contactAssocId}`, {
      preserveScroll: true,
    })
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            <Users className="h-4 w-4" />
            Contacts ({contacts.length})
          </CardTitle>
          {!isTerminal && (
            <Button variant="outline" size="sm" onClick={() => setAddOpen(true)}>
              <Plus className="mr-1.5 h-4 w-4" />
              Ajouter
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {contacts.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-4">
            Aucun contact associe a cette opportunite.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nom</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Role</TableHead>
                {!isTerminal && <TableHead className="w-10" />}
              </TableRow>
            </TableHeader>
            <TableBody>
              {contacts.map((c) => (
                <TableRow key={c.id}>
                  <TableCell className="font-medium">{c.contact_name}</TableCell>
                  <TableCell className="text-muted-foreground">{c.contact_email}</TableCell>
                  <TableCell>
                    <Badge variant="secondary">{c.role.label}</Badge>
                  </TableCell>
                  {!isTerminal && (
                    <TableCell>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-7 w-7 text-muted-foreground hover:text-destructive"
                        onClick={() => handleRemove(c.id)}
                      >
                        <Trash2 className="h-3.5 w-3.5" />
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>

      <AddContactSheet
        open={addOpen}
        onOpenChange={setAddOpen}
        opportunityId={opportunityId}
      />
    </Card>
  )
}
